import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-ilerleme-cubugu',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ilerleme-kapsayici" [class]="boyut()">
      <div class="ilerleme-ust" *ngIf="etiket() || true">
        <span class="ilerleme-etiket" *ngIf="etiket()">{{ etiket() }}</span>
        <span class="ilerleme-yuzde">{{ clampDeger() }}%</span>
      </div>
      <div class="ilerleme-ray">
        <div class="ilerleme-dolgu"
          [class.cizgili]="cizgili()"
          [style.width.%]="clampDeger()"
          [style.background-color]="renk()"
        ></div>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; width: 100%; }

    .ilerleme-kapsayici { width: 100%; }

    .ilerleme-ust {
      display: flex; justify-content: space-between; align-items: center;
      margin-bottom: 4px; font-size: 12px;
    }
    .ilerleme-etiket { color: var(--py-metin, #333); opacity: 0.75; font-weight: 500; }
    .ilerleme-yuzde { color: var(--py-metin, #333); font-weight: 700; margin-left: auto; }

    .ilerleme-ray {
      width: 100%; background: rgba(128,128,128,0.12); border-radius: 100px; overflow: hidden;
    }
    .ilerleme-dolgu {
      height: 100%; border-radius: 100px; min-width: 0;
      transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .kucuk .ilerleme-ray { height: 6px; }
    .kucuk .ilerleme-ust { font-size: 11px; margin-bottom: 2px; }

    .orta .ilerleme-ray { height: 10px; }

    .buyuk .ilerleme-ray { height: 16px; }
    .buyuk .ilerleme-ust { font-size: 13px; margin-bottom: 6px; }

    .cizgili {
      background-image: linear-gradient(
        45deg,
        rgba(255,255,255,0.2) 25%, transparent 25%,
        transparent 50%, rgba(255,255,255,0.2) 50%,
        rgba(255,255,255,0.2) 75%, transparent 75%,
        transparent
      );
      background-size: 20px 20px;
      animation: cizgiKaydir 0.8s linear infinite;
    }

    @keyframes cizgiKaydir {
      from { background-position: 20px 0; }
      to { background-position: 0 0; }
    }
  `],
})
export class IlerlemeCubuguComponent {
  deger = input(0);
  renk = input('#1890ff');
  etiket = input<string | undefined>(undefined);
  boyut = input<'kucuk' | 'orta' | 'buyuk'>('orta');
  cizgili = input(false);

  clampDeger = computed(() => Math.max(0, Math.min(100, this.deger())));
}
